import { render, staticRenderFns } from "./tag-input.vue?vue&type=template&id=108f4f13&scoped=true&"
import script from "./tag-input.vue?vue&type=script&lang=js&"
export * from "./tag-input.vue?vue&type=script&lang=js&"
import style0 from "./tag-input.vue?vue&type=style&index=0&id=108f4f13&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f4f13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/aurelien/dev/frk/vue-tags-input/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('108f4f13')) {
      api.createRecord('108f4f13', component.options)
    } else {
      api.reload('108f4f13', component.options)
    }
    module.hot.accept("./tag-input.vue?vue&type=template&id=108f4f13&scoped=true&", function () {
      api.rerender('108f4f13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue-tags-input/tag-input.vue"
export default component.exports